module.exports = __webpack_public_path__ + "img/tiki.a7e3dda3.png";